import { render, staticRenderFns } from "./liveBroadcastImport.vue?vue&type=template&id=36d0bd9f&scoped=true&"
import script from "./liveBroadcastImport.vue?vue&type=script&lang=js&"
export * from "./liveBroadcastImport.vue?vue&type=script&lang=js&"
import style0 from "./liveBroadcastImport.vue?vue&type=style&index=0&id=36d0bd9f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0bd9f",
  null
  
)

export default component.exports